export function normalizeExternalUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";

  const candidate = /^[a-z][a-z\d+.-]*:/i.test(raw)
    ? raw
    : `https://${raw.replace(/^\/\//, "")}`;

  try {
    const url = new URL(candidate);
    return url.protocol === "http:" || url.protocol === "https:"
      ? url.href
      : "";
  } catch {
    return "";
  }
}
